import React from 'react'
import Manager from 'tyan/public/components/Manager'
import InstrumentRepairDetail from './InstrumentRepairDetail'
import InstrumentDetail from '../InstrumentDetail'

Ext.require('Ext.Toast')

const config = {
    tabs: {
        '维修中': {
            buttons: [
            ],
            columns: [
                { _text: '申请编号', field: 'Number', minWidth: 150, locked: false, search: true, },
                {
                    _text: '设备编号', field: 'InstrumentNumber', minWidth: 150, search: true,
                    tools: [{
                        _tool: '', btnName: '查_看2', zone: 'end',
                        handler: ({ showDetail, refreshPage }, data) => { showDetail(props => <InstrumentDetail {...props} id={data.InstrumentID} readOnly={true} />) }
                    }]
                },
                { _text: '设备名称', field: 'InstrumentName', minWidth: 150, flex: 1, search: true, },
                { _text: '型号', field: 'InstrumentModel', minWidth: 150, filter: true, },
                { _text: '制造厂', field: 'InstrumentManufactor', minWidth: 150, filter: true, },
                { _text: '试验类型', field: 'TestType', minWidth: 150, filter: true, },
                { _text: '申请人', field: 'Creator', minWidth: 120, filter: true, },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, filter: true, },
                { _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, },
                { _: '', name: 'InstrumentID', field: 'InstrumentID' },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => showDetail(props => <InstrumentRepairDetail {...props} id={data.id} />),
        },
        '退回维修': {
            buttons: [
            ],
            columns: [
                { _text: '申请编号', field: 'Number', minWidth: 150, locked: false, search: true, },
                {
                    _text: '设备编号', field: 'InstrumentNumber', minWidth: 150, search: true,
                    tools: [{
                        _tool: '', btnName: '查_看2', zone: 'end',
                        handler: ({ showDetail, refreshPage }, data) => { showDetail(props => <InstrumentDetail {...props} id={data.InstrumentID} readOnly={true} />) }
                    }]
                },
                { _text: '设备名称', field: 'InstrumentName', minWidth: 150, flex: 1, search: true, },
                { _text: '型号', field: 'InstrumentModel', minWidth: 150, filter: true, },
                { _text: '制造厂', field: 'InstrumentManufactor', minWidth: 150, filter: true, },
                { _text: '试验类型', field: 'TestType', minWidth: 150, filter: true, },
                { _text: '申请人', field: 'Creator', minWidth: 120, filter: true, },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, filter: true, },
                { _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, },
                { _text: '退回原因', field: 'ReturnReason', minWidth: 150, filter: true, },
                { _: '', name: 'InstrumentID', field: 'InstrumentID' },
                // { _: '', name: 'taskName', field: 'Task.TaskName' },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => showDetail(props => <InstrumentRepairDetail {...props} id={data.id} /* taskName={data.taskName} */ />),
        },
    },
}

export default props => <Manager {...props} config={config} />